/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Data from '../../HomePage/Data.png';
import Charts from '../../HomePage/Charts.png';
const WatchListRightSide = ({ styles, isMobile }) => {
  return (
    <div
      style={{
        ...styles.rightSideMainDiv,
        marginTop: isMobile ? '30px' : '0px',
      }}
    >
      <a
        href="https://optionsgeek.com/3-steps-to-profit-members-area/the-ultimate-guide-to-unusual-options-activity/"
        target="_blank"
        style={{ textDecoration: 'none' }}
      >
        <div style={styles.imageDiv}>
          <img src="uoapic.png" height="100%" width="100%" alt="" />
        </div>
      </a>

      <a
        href="https://marketchameleon.com/?pap_aid=Felix"
        target="_blank"
        style={{ textDecoration: 'none' }}
      >
        <div style={{ ...styles.imageDiv, padding: '10px' }}>
          <img src={Data} width="100%" height="100%" alt="" />
        </div>
      </a>
      <a
        href="https://www.tradingview.com/?offer_id=10&aff_id=13279"
        target="_blank"
        style={{ textDecoration: 'none' }}
      >
        <div style={styles.imageDiv}>
          <img height="100%" width="100%" src={Charts} alt="" />
        </div>
      </a>
    </div>
  );
};
export default WatchListRightSide;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/components/WatchListrightSide.jsx